import React from "react";
import { Redirect } from "react-router-dom";

// ponytail: role 5 has the list as its only page, so /orders just forwards
// there. The nav's Orders link points at /orders, so this route must exist.
const index = props => <Redirect to="/orders/list" />;

export default index;
